var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAeLogoV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 131.185,
    viewBox: "0 0 126 131.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 131.185,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.627,121.518C-2.941,102.6-8.156,62.125,13,31.288S73.8-9.248,101.372,9.668,134.155,69.061,113,99.9s-60.8,40.536-88.369,21.62M99.217,12.809C71.639-6.114,37.258,7.443,18.37,34.97S4.137,98.629,28.746,115.514s60,8.228,78.883-19.3,16.2-66.521-8.412-83.407",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4,73.438,46.279,123.475c-1.788,5.227,6.483,7.472,8.26,2.278L71.658,75.715c1.788-5.227-6.483-7.472-8.26-2.277",
    transform: "translate(-22.132 -33.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.515,71.1Q85.9,95.787,91.956,120.32c1.321,5.349,9.584,3.083,8.26-2.277Q94.16,93.512,88.776,68.823c-1.174-5.384-9.435-3.106-8.26,2.277",
    transform: "translate(-38.661 -31.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.778,142.5a207.328,207.328,0,0,1,28.773-6.3c2.291-.333,3.549-3.237,2.991-5.269-.675-2.459-2.971-3.325-5.268-2.991a207.478,207.478,0,0,0-28.773,6.3c-5.277,1.553-3.031,9.823,2.277,8.26",
    transform: "translate(-20.433 -61.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.472,87.045a149.547,149.547,0,0,1,26.057-8.86c5.356-1.3,3.088-9.56-2.277-8.26a161.278,161.278,0,0,0-28.1,9.723c-2.11.947-2.615,4.016-1.537,5.86,1.27,2.172,3.742,2.488,5.86,1.537",
    transform: "translate(-56.289 -33.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.654,118.094a142.142,142.142,0,0,1,21.241-7.169c5.338-1.361,3.076-9.625-2.277-8.26A155.833,155.833,0,0,0,126.33,110.7c-2.124.917-2.6,4.036-1.537,5.86,1.284,2.195,3.728,2.457,5.86,1.537",
    transform: "translate(-59.744 -49.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8,145.283a85.327,85.327,0,0,1,27.687-8.762c2.294-.317,3.547-3.249,2.991-5.269-.679-2.471-2.967-3.309-5.268-2.991a91.968,91.968,0,0,0-29.734,9.626c-4.9,2.537-.569,9.932,4.324,7.4",
    transform: "translate(-62.184 -61.643)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeLogoV2);
export default __webpack_public_path__ + "static/media/AE_logo_V2.2c8c6815d506f760ce73d9a4091300a5.svg";
export { ForwardRef as ReactComponent };